module.exports = __webpack_public_path__ + "trust-logo-809d020fa4c13f5dad7c.svg";